var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLadderTrophy = function SvgLadderTrophy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#232322",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.29 18.108h-.899s-4.248-.554-4.248-4.722a4.71 4.71 0 0 1 2.756-4.293m14.53.894q.129.55.162 1.114a3.54 3.54 0 0 1 4.267 3.465c0 3.597-3.78 3.541-3.78 3.541h-1.06m-9.286-5.279h6.362m-3.178-3.831c0-2.64-4.235.651-4.33-7.27a.39.39 0 0 1 .383-.39h7.891a.39.39 0 0 1 .384.39c-.097 7.928-4.328 4.63-4.328 7.27m0 0v3.831m-4.33-10.403h-3.24a.473.473 0 0 0-.474.47v.05c.13 1.398.474 5.062 4.243 4.03l.758-.296m7.35-4.254h3.388a.473.473 0 0 1 .474.52c-.121 1.353-.45 4.822-3.886 4.116L18.85 6.8m-5.707 9.714-1.132 14.152m6.796-14.176 1.132 14.146m-7.838-1.283h7.734m-7.255-5.79h6.793m-6.335-5.74h5.876",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgLadderTrophy;